// extracted by mini-css-extract-plugin
export default {"panel":"AdminPanel_panel__2jNIi","logout":"AdminPanel_logout__VPWM2"};